import image1 from '../../assets/images/home_banner1.jpg'
import image2 from '../../assets/images/bigstock-Dubai-Marina-New-Dubai-62452307-2.jpg'
import image3 from '../../assets/images/how-much-does-it-cost-to-live-in-bangkok.jpg'
import image4 from '../../assets/images/nyc-wallpaper-wp60010530.jpg'

export default [
	{
		title: 'PRINCIPAL INVESTMENTS <br/> AND <br /> ADVISORY BUSINESS',
		description: '',
		button: 'Read More',
		image: image1,
	},
	{
		title: 'WITH PARTNER <br>  OFFICES IN',
		description:
			'SINGAPORE, HONG KONG, THAILAND, INDONESIA AND CAMBODIA',
		button: 'Discover',
		image: image2,
	},
	{
		title: 'WE BELIEVE <br> GREAT INVESTMENTS AND RESULTS',
		description:
			'COME FROM MEANINGFUL COLLABORATION',
		button: 'Buy now',
		image: image3,
	},
	{
		title: 'WE BUILD, SEED AND GROW COMPANIES',
		description:
			'BY FOCUSING ON OPERATIONAL EXCELLENCE',
		button: 'Read More',
		image: image4,
	}
];


// WEBPACK FOOTER //
// ./src/components/Home/content.js